/** Derives a short class code from a display name (e.g. "Math 10 A" → "MATH10A"). */
export function classCodeFromName(name: string): string {
  const alphanumeric = name.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
  return alphanumeric.slice(0, 12) || `CLASS${Date.now().toString(36).toUpperCase()}`;
}

export function ensureUniqueClassCode(baseCode: string, existingCodes: readonly string[]): string {
  const normalized = new Set(existingCodes.map((code) => code.toUpperCase()));
  let candidate = baseCode.toUpperCase();
  let suffix = 1;

  while (normalized.has(candidate)) {
    candidate = `${baseCode.toUpperCase()}${suffix}`;
    suffix += 1;
  }

  return candidate;
}
